module.exports = __webpack_public_path__ + "static/media/41.7902d432.jpg";